import type { KeyboardEvent } from 'react';

export function onKeyPress(
	event: KeyboardEvent<HTMLInputElement> | KeyboardEvent<HTMLTextAreaElement> | KeyboardEvent<HTMLSelectElement>
) {
	if (event.key === 'Enter') {
		const focusedElement = event.currentTarget;
		const nextElementId = focusedElement.getAttribute('data-nextelement');
		if (nextElementId) {
			const nextElement = document.getElementById(nextElementId);
			if (nextElement) {
				nextElement.focus();
			}
		}
		event.preventDefault();
		return;
	}
}
